module.exports = __webpack_public_path__ + "img/CY110009.40c6aa7a.png";